import { useState } from "react";
import { HeartPulse, LifeBuoy, X, Phone } from "lucide-react";

export const AvvisoSalute = () => (
  <div data-testid="avviso-salute" className="rounded-xl border border-amber-500/40 bg-[#1c0f2b] p-4 text-left">
    <div className="flex items-start gap-3">
      <HeartPulse className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
      <p className="text-purple-100/90 text-xs leading-relaxed">
        Arcana offre un consulto di cartomanzia, non una valutazione medica. Le interpretazioni delle carte
        non costituiscono diagnosi né confermano la presenza di una malattia. Per dubbi o sintomi,
        rivolgiti a un professionista sanitario.
      </p>
    </div>
  </div>
);

export const FinestraAiuto = ({ onClose }) => (
  <div data-testid="finestra-aiuto" className="rounded-xl border border-rose-400/50 bg-[#241028] p-5 text-left relative">
    <button
      onClick={onClose}
      data-testid="finestra-aiuto-chiudi"
      aria-label="Chiudi"
      className="absolute top-3 right-3 text-purple-300/60 hover:text-purple-100 transition-colors"
    >
      <X className="w-4 h-4" />
    </button>
    <div className="flex items-start gap-3">
      <LifeBuoy className="w-6 h-6 text-rose-300 shrink-0 mt-0.5" />
      <div className="space-y-3">
        <p className="font-display text-amber-100 text-base">Le carte parlano di una situazione che può fare male</p>
        <p className="text-purple-100/85 text-xs leading-relaxed">
          In questa lettura le carte descrivono tensioni, soprusi o una relazione che porta sofferenza.
          Se nella tua vita c'è qualcuno che ti spaventa, ti controlla, ti umilia o ti fa del male,
          non affrontarlo da sola: esistono persone preparate ad ascoltarti e aiutarti,
          in modo gratuito e riservato, a qualsiasi ora.
        </p>
        <div className="space-y-2 text-xs">
          <a href="tel:112" data-testid="aiuto-112" className="flex items-center gap-2 text-amber-200 hover:text-amber-100 transition-colors">
            <Phone className="w-3.5 h-3.5" /> <span><strong>112</strong> — pericolo immediato o emergenza</span>
          </a>
          <a href="tel:1522" data-testid="aiuto-1522" className="flex items-center gap-2 text-amber-200 hover:text-amber-100 transition-colors">
            <Phone className="w-3.5 h-3.5" /> <span><strong>1522</strong> — violenza di genere e stalking, gratuito, attivo 24 ore su 24</span>
          </a>
          <a href="tel:114" data-testid="aiuto-114" className="flex items-center gap-2 text-amber-200 hover:text-amber-100 transition-colors">
            <Phone className="w-3.5 h-3.5" /> <span><strong>114</strong> — Emergenza Infanzia, se sono coinvolti minori</span>
          </a>
          <a href="https://www.1522.eu" target="_blank" rel="noopener noreferrer" data-testid="aiuto-link-1522"
             className="inline-block mt-1 text-purple-200/80 hover:text-purple-100 underline underline-offset-2 transition-colors">
            www.1522.eu — sito ufficiale del servizio
          </a>
        </div>
        <button
          onClick={onClose}
          data-testid="finestra-aiuto-chiudi-btn"
          className="mt-1 text-[11px] uppercase tracking-wider text-purple-300/70 hover:text-purple-100 border border-purple-400/30 hover:border-amber-400/50 rounded-full px-4 py-1.5 transition-colors"
        >
          Chiudi
        </button>
      </div>
    </div>
  </div>
);

export const ReadingAlerts = ({ avvisi }) => {
  const [aiutoChiuso, setAiutoChiuso] = useState(false);
  if (!avvisi || (!avvisi.salute && !avvisi.aiuto)) return null;
  return (
    <div className="space-y-3 mt-6" data-testid="reading-alerts">
      {avvisi.aiuto && !aiutoChiuso && <FinestraAiuto onClose={() => setAiutoChiuso(true)} />}
      {avvisi.salute && <AvvisoSalute />}
    </div>
  );
};
